import Icon from './Icon';
import { useTheme } from '../lib/useTheme';

interface Props {
  /** Visual variant. `inline` lives in the nav (desktop); `fab` floats
   *  in the bottom-right corner with elevation (mobile). */
  variant?: 'inline' | 'fab';
}

/**
 * Icon button that flips the site between light and dark mode.
 *
 * Shows a moon when the page is currently light (click to go dark) and a
 * sun when the page is currently dark (click to go light). Mirrors the
 * affordance pattern used by macOS, Linear, etc.
 */
export default function ThemeToggle({ variant = 'inline' }: Props) {
  const { resolved, toggle } = useTheme();
  const isDark = resolved === 'dark';
  const label = isDark ? 'Switch to light mode' : 'Switch to dark mode';

  return (
    <button
      type="button"
      className={`theme-toggle theme-toggle--${variant}`}
      onClick={toggle}
      aria-label={label}
      title={label}
    >
      <Icon name={isDark ? 'sun' : 'moon'} size={variant === 'fab' ? 20 : 18} />
    </button>
  );
}
